import React, { FunctionComponent, ReactNode } from 'react';
import { Box, SxProps } from '@mui/material';

interface PageContainerProps {
    children: ReactNode;
    sx?: SxProps;
    containerName?: string;
    innerSx?: SxProps;
}

const PageContainer: FunctionComponent<PageContainerProps> = ({
    children,
    sx,
    containerName,
    innerSx,
}) => {
    return (
        <Box
            data-testid={containerName}
            sx={{ display: 'flex', justifyContent: 'center', padding: '16px', ...sx }}
        >
            <Box
                data-testid={`${containerName}_inner_container`}
                sx={{ width: '1185px', display: 'flex', margin: '0 auto', ...innerSx }}
            >
                {children}
            </Box>
        </Box>
    );
};

export default PageContainer;
